<div class="w-full flex flex-col gap-4 p-4" [formGroup]="form">
    <p-card class="md:max-w-250">
        <div class="w-full flex flex-col gap-4">
            <h1 class="text-2xl font-bold">Editar Usuário</h1>

            <div class="w-full grid sm:grid-cols-2 grid-cols-1 gap-4 items-end">
                <app-input-cpf-cnpj
                    label="CPF ou CNPJ"
                    formControlName="CPF_CNPJ"
                    [row]="true"
                ></app-input-cpf-cnpj>

                <app-input
                    id="nome"
                    label="Nome"
                    formControlName="NOME"
                ></app-input>

                <app-input
                    id="email"
                    label="Email"
                    formControlName="EMAIL"
                ></app-input>

                <app-input
                    id="login"
                    label="Login"
                    formControlName="LOGIN"
                ></app-input>

                <app-input
                    id="senha"
                    type="password"
                    label="Senha"
                    formControlName="SENHA"
                    [isReadOnly]="true"
                ></app-input>

                <app-input
                    id="confirmarsenha"
                    type="password"
                    label="Confirmar a senha"
                    [(ngModel)]="confirmarSenha"
                    [ngModelOptions]="{ standalone: true }"
                ></app-input>

                <app-input-telefone
                    label="Celular"
                    formControlName="CELULAR"
                ></app-input-telefone>

                <app-input
                    id="acesso"
                    label="Acesso"
                    formControlName="ACESSO"
                ></app-input>

                <app-input
                    id="chaveativacao"
                    label="Chave ativação"
                    formControlName="CHAVE_ATIVACAO"
                ></app-input>

                <app-select
                    [icon]="true"
                    [options]="tipoSelect"
                    formControlName="TIPO"
                    label="Tipo"
                ></app-select>
            </div>

            <div
                class="w-full flex sm:flex-row flex-col gap-4 justify-end items-end"
            >
                <app-button
                    variant="danger"
                    (click)="cancelar()"
                    class="md:max-w-45 w-full"
                    >Cancelar</app-button
                >

                <app-button
                    variant="success"
                    (click)="processarFormulario()"
                    class="md:max-w-45 w-full"
                    >Salvar</app-button
                >
            </div>
        </div>
    </p-card>
</div>
